// ==============================|| THEME CONFIG  ||============================== //


const config = {
    defaultPath: window.location.pathname.indexOf('/dashboard/') > -1 ? '/dashboard/' : '/',
    fontFamily: `'Public Sans', sans-serif`,
    i18n: 'en',
    miniDrawer: false,
    container: true,
    mode: 'light',
    presetColor: 'default',
    themeDirection: 'ltr',
    shopifyClientId: process.env.NODE_ENV === 'production' ? "7aa7fc55492b3f7a36de209c30ea6251" : "183ff24117b78c6d0804ef383fb11ff3",
    baseUrl:  window.location.origin + (window.location.pathname.indexOf('/dashboard/') > -1 ? '/dashboard/' : '/'),
    apiUrl: process.env.NODE_ENV === 'production' ? 'https://api.convertlogistics.com/api' : (window.location.port > 100 ? window.location.origin.replace(':'+window.location.port, '') : window.location.origin) + '/api',
    frontendUrl: process.env.NODE_ENV === 'production' ? 'https://www.convertlogistics.com/' : (window.location.port > 100 ? window.location.origin.replace(':'+window.location.port, '') : window.location.origin) + '/',
};

export default config;
export const drawerWidth = 260;

export const twitterColor = '#1DA1F2';
export const facebookColor = '#3b5998';
export const linkedInColor = '#0e76a8';
